import { Text } from "@dxp-feed/ui/Text";
import { Box } from "@dxp-feed/ui/Box";
import React from "react";
import { SiteContainer } from "@/components/Container";

const SubHeading:React.FC<any>  = ({ props }) => {
  return (
    <SiteContainer className="mx-0 lg:mx-auto">
  <Box as="div" className="pb-3 md:pb-6 lg:pb-8 text-left lg:text-center">
    <Text as="h2" className="font-raleway  text-xl xs:text-3xl">
      {props?.heading}
    </Text>
  </Box>
</SiteContainer>
  );
};

export default SubHeading;
